import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import {
  CustomResultOfListOfPlanListItemForBuyDto,
  PlanListItemForBuyDto,
} from 'src/app/core/api/models';
import { PlansService } from 'src/app/core/api/services';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { RefreshMenuService } from 'src/app/core/services/refresh-menu.service';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { GetPlansTypeModuleComponent } from '../../plans-type-module/get-plans-type-module/get-plans-type-module.component';

export interface ListOfPlanListItemForBuyDto {
  items?: Array<PlanListItemForBuyDto>;
  totalCount?: number;
}

@Component({
    selector: 'app-get-plans-type-package',
    templateUrl: './get-plans-type-package.component.html',
    styleUrls: ['./get-plans-type-package.component.scss'],
    standalone: false
})
export class GetPlansTypePackageComponent
  extends GetPlansTypeModuleComponent
  implements OnInit
{
  //#region properties

  pageName = 'plans.planListPackageForUser';
  tabName: string = 'getPlansTypePackage';

  //#endregion

  constructor(
    protected currentService: PlansService,
    protected dynamicTabService: DynamicTabService,
    public refreshMenuService: RefreshMenuService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    private router: Router
  ) {
    super(
      currentService,
      dynamicTabService,
      refreshMenuService,
      tabsDynamicComponent
    );
  }

  //#region api

  //get All
  getPaginationApi(): Observable<CustomResultOfListOfPlanListItemForBuyDto> {
    return this.currentService.plansGetPlansTypePackage({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  //Create
  baseCreateGetApi(selectedPlanModule: PlanListItemForBuyDto) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/plan/${selectedPlanModule.id}`], {
        queryParams: { isFromPanel: 'true' },
      })
    );
    window.open(url, '_blank');
  }
  //#endregion
}
